export enum Section {
  PLACE_ORDER_VIEW = 'myLK_order',
  PLACED_ORDER_VIEW = 'myLK_OrderPlaced',
  TRACKING_ORDER_VIEW = 'myLK_TrackingOrder',
  REFERRAL_MODAL = 'RafModal',
  REFERRAL_VIEW = 'referrals',
  LOOK_IN = 'shop',
  NBA = 'nextBestAction',
}
